import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_URL } from '../../config';
import { toApiError } from '../../lib/api-error';

type ConversionResult = {
  workflowId: string;
  jobId: string | null;
  created: boolean;
  state: 'generating' | 'ready';
};

export function useExternalTestConversion(runId: string, itemId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<ConversionResult> => {
      const response = await fetch(
        `${API_URL}/external-tests/runs/${runId}/items/${itemId}/convert-to-workflow`,
        { method: 'POST', credentials: 'include' }
      );
      if (!response.ok) throw await toApiError(response, 'Failed to convert external test');
      const body = (await response.json()) as { ok: true } & ConversionResult;
      return body;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['external-run', runId] }),
  });
}
